import React from "react"
import styles from "./Selector.module.css"
import Label from "./Label"
import RequiredNotice from "./RequiredNotice"
import { ERRORS } from "./constants"
import { IconWithExplanation } from "frontend/components/icons"

const Selector = ({ options, onChange, value, label, id, required, error, explanation, className }) => {
  if (options.length === 0) {
    return null
  }

  const handleChange = (e, key) => {
    e.stopPropagation()
    e.preventDefault()
    onChange(key)
  }

  return (
    <div className={`${styles.container} ${className}`} data-testid="container">
      <Label id={id} required={required} hasError={Boolean(error)}>
        {label}
      </Label>
      <div className={styles.selectorContainer}>
        <div className={styles.selector} data-testid="selector">
          {options.map((option) => (
            <button
              data-testid={option.key}
              className={`${styles.option} ${option.key === value ? styles.selected : ""}`}
              key={option.key}
              onClick={(e) => handleChange(e, option.key)}
            >
              <h5 className={styles.text}>{option.label}</h5>
            </button>
          ))}
        </div>
        {explanation && (
          <IconWithExplanation className={styles.icon} explanation={explanation} icon="exclamation-circle" />
        )}
      </div>
      <RequiredNotice required={required} hasError={error === ERRORS.required} />
    </div>
  )
}

Selector.defaultProps = {
  options: [],
  value: "",
  onChange: () => {},
  error: "",
  className: "",
}

export default Selector
